var map = {
  "./": "9036",
  "./edit": "22",
  "./edit.js": "22",
  "./index": "9036",
  "./index.js": "9036",
  "./new": "43894",
  "./new.js": "43894",
  "./show": "34639",
  "./show.js": "34639"
};


function __rspack_context(req) {
  var id = __rspack_context_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context.keys = function webpackContextKeys() {
  return Object.keys(map);
};
__rspack_context.resolve = __rspack_context_resolve;
module.exports = __rspack_context;
__rspack_context.id = 10240;
